import React, { useCallback, useEffect, useMemo, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { getWarehouseKeyValueList } from "../../../services/index";
import Select from "react-select";
import { getStockTransferList, stockTransferApprove, stockTransferCancel, } from "../../../services/Inventory/OtherServices";
import AddIcon from "@mui/icons-material/Add";
import { Link, useNavigate } from "react-router-dom";
import PaginationDataTable from "../../Common/PaginationDataTable";
import { STOCK_TRANSFER_URL } from "../../../CONSTANTS";
import EditIcon from '@mui/icons-material/Edit';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { ReceiptOutlined } from "@mui/icons-material";

const StockTransferRecieved = (props) => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [search, setSearch] = useState("");
  const [wareOptions, setWareOptions] = useState(null);
  const [selectedWarehouse, setSelectedWarehouse] = useState({
    value: "",
    label: "Select Warehouse",
  });
  const [data, setData] = useState("")
  const [refreshFlag, setRefreshFlag] = useState(0);
  const handleRefresh = useCallback(() => {
    setRefreshFlag(refreshFlag + 1);
  }, [refreshFlag]);

  const handleAprove = (row) => {
    stockTransferApprove(row.uuid).then((res) => {
      if (res.errorCode === 0) {
        toast.success(res.message);
        handleRefresh();
      } else {
        toast(res.message);
        return;
      }
    });
  };

  const handleCancel = (row) => {
    stockTransferCancel(row.uuid).then((res) => {
      if (res.errorCode === 0) {
        toast.success(res.message);
        handleRefresh();
      } else {
        toast(res.message);
        return;
      }
    });
  }

  const columns = useMemo(() => [
    {
      name: "STOCK CODE",
      cell: (row) => row.stockTransferCode,
      style: { color: "#007bff" },
    },
    {
      name: "CREATION DATE",
      cell: (row) => row.stockTransferDate,
    },
    {
      name: "FROM WAREHOUSE",
      cell: (row) => row.fromWarehouseTitle,
    },
    {
      name: "TO WAREHOUSE",
      cell: (row) => row.toWarehouseTitle,
    },
    {
      name: "STATUS",
      cell: (row) => row.stockTransferStatusEnum,
    },
    {
      name: 'ACTION',
      style: { cursor: "pointer" },
      cell: (row) => (
        <div>
          {/* {row.stockTransferStatusEnum !== "Approved" && row.stockTransferStatusEnum !== "Cancelled" && (
            <EditIcon
              style={{ fontSize: "15px", cursor: "pointer" }}
              onClick={() => navigate("/stockTransfer/" + row.uuid + "/edit")}
            />
          )} */}
          {/* &nbsp;&nbsp; */}
          {/* {row.stockTransferStatusEnum !== "Cancelled" && row.stockTransferStatusEnum !== "Approved" && <ThumbUpAltIcon
            style={{
              fontSize: '15px',
              cursor: 'pointer',
              color: 'greenyellow',
            }}
            onClick={() => handleAprove(row)}
          />} */}
          {/* {row.stockTransferStatusEnum !== "Approved" && row.stockTransferStatusEnum !== "Cancelled" && (
            <HighlightOffIcon
              onClick={() => handleCancel(row)}
            />
          )} */}
{/* 
          {(row.stockTransferStatusEnum === "Cancelled" || row.stockTransferStatusEnum === "Approved") && (
            <>-</>
          )} */}
          {(true) && (
            <><ReceiptOutlined onClick={() => navigate("/stockTransfer/" + row.uuid + "/edit", { state: "Receipt" })}/></>
          )}
          &nbsp;
        </div>
      ),
    }
  ], [handleAprove, handleCancel, handleRefresh]);


  useEffect(() => {
    if (!wareOptions) {
      getWarehouseKeyValueList().then((res) => {
        if (res.errorCode === 0) {
          const options = res.responsePacket?.map((d) => ({
            value: d.key,
            label: d.value,
          }));
          setWareOptions(options);
          setSelectedWarehouse(options[0]);
        } else {
          toast(res.message);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (selectedWarehouse && selectedWarehouse.value !== "") {
      setSearch("");
      getList();
    }
  }, [selectedWarehouse]);

  useEffect(() => {
    if (list) {
      const result = list.filter((data) => {
        return (
          data.code.toLowerCase().includes(search.toLowerCase()) ||
          data.createdAt.toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredList(result);
    }
  }, [search]);

  const getList = () => {
    let data = {
      page: 0,
      search: "",
      size: -1,
      uuid2: selectedWarehouse?.value,
    };

    getStockTransferList(data)?.then((res) => {
      if (res.errorCode === 0) {
        let response = res.responsePacket.data;
        const stockTransferId = response.map((item) =>{
          setData(item.uuid);
        })
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleRowClick = (data) => {
    navigate(`/stockTransfer/${data.uuid}`, {
      state: { selectedWarehouse: selectedWarehouse },
    });
  };

  return (
    <>
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mb-0 font-size-18 font-weight-bolder text-uppercase w-100">
            Stock Transfer Received list
          </h3>
        </div>
        <>
          <div className="tab-content issuanceList" id="myTabContent">
            <div className="tab-pane fade show active" id="issuanceList" role="tabpanel" aria-labelledby="activeList">
              <div className="issuance-warehouse" style={{ zIndex: 6 }}>
                <Select
                  options={wareOptions}
                  placeholder={"Select WareHouse"}
                  onChange={(e) => setSelectedWarehouse(e)}
                  value={selectedWarehouse}
                  maxMenuHeight={220}
                />
              </div>
              {selectedWarehouse.value && filteredList && (
                <PaginationDataTable
                  paginationUrl={STOCK_TRANSFER_URL() + "getAllApprovedRecords"}
                  serverSidePagination={true}
                  search={true}
                  pagination={false}
                  className="position-relative customDataTable"
                  columns={columns}
                  showNewBtn={true}
                  filter={{
                    uuid2: selectedWarehouse?.value,
                  }}
                  loading={true}
                  onRowClicked={(data) => handleRowClick(data)}
                />
              )}
            </div>
          </div>
        </>
      </div>
      <Toaster />
    </>
  );
};

export default StockTransferRecieved;
